module.exports = __webpack_public_path__ + "static/5star_doris-2e05cc06ccfa376cd922929440d11780.jpg";